/**
 * The workflow sections this renderer carries — the single place one is
 * registered: the three standard sections of a workflow's view
 * (`docs/proposals/workflows.md`, "Workflow UI"), in page order. Each is shown
 * only for a workflow that declares it (`sections` on `GET /workflows`,
 * `src/agent/src/workflow/catalog.ts`). Fixed at build time, because each is a
 * hook and hooks cannot come and go between renders.
 *
 * Which workflows exist, in what state and with which sections, is the agent's
 * to say (`lib/workflowList.ts`); this side keeps no table per workflow.
 */

import type { WorkflowSection } from "./types";
import { useEndReportView } from "./end-report/useEndReportChat";
import { useWorkJournalView } from "./work-journal/useWorkJournal";
import { useWorkSettingsView } from "./work-settings/useWorkSettingsChat";

export const WORKFLOW_SECTIONS: readonly WorkflowSection[] = [
  { id: "setup", useView: useWorkSettingsView },
  { id: "progress", useView: useWorkJournalView },
  { id: "results", useView: useEndReportView },
];

/** Continuing a cut-off run: the agent's read of what is pending, and the control the view shows. */
export { ContinueBar } from "./continue/ContinueBar";
export { useContinueRun, type ContinueState } from "./continue/useContinueRun";

/** The Workflows page's rules and the thread-to-workflow lookup the chat pane uses. */
export {
  DEFAULT_WORKFLOW_SORT,
  WORKFLOW_CATEGORIES,
  WORKFLOW_SECTION_ORDER,
  defaultSection,
  listWorkflows,
  openWorkflow,
  rememberThreadWorkflow,
  useThreadWorkflow,
  type OpenWorkflow,
  type ThreadWorkflow,
  type WorkflowPhase,
  type WorkflowSectionId,
  type WorkflowSort,
} from "./catalog";
